import api from '@shop/frontend/web/js/api';
import { reactive, readonly } from 'vue';

const DEFAULT_CALENDAR_STATE = {
  data: [],
  isLoading: false,
  error: null,
};

const calendarState = reactive(DEFAULT_CALENDAR_STATE);

const getActualDates = async () => {
  try {
    calendarState.isLoading = true;
    const res = await api.calendar.getActualDates();
    calendarState.data = (() => {
      if (!res) return [];
      return Array.isArray(res) ? res : [res];
    })();
  } catch (e) {
    calendarState.error = e;
  } finally {
    calendarState.isLoading = false;
  }
};

export default function useCalendarStore() {
  return {
    getActualDates,
    calendarState: readonly(calendarState),
  };
}
